function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import moment from 'moment';
import { dailyRecordsShape, weeklyRecordsShape, monthlyRecordsShape, previewShape } from 'shapes/bins';
import BloodGlucoseProfileMiniChart from 'components/Charts/BloodGlucoseProfileMiniChart';
import App from 'modules/App';
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import { DAYS_SELECTOR_ZOOM } from '../../constants';
import messages from '../../messages';
import DaysSelectorControlBtn from '../DaysSelectorControlBtn';
import styles from './DaysSelector.pcss';
var _React_PureComponent;
class DaysSelector extends (_React_PureComponent = React.PureComponent) {
    componentDidUpdate(prevProps) {
        if (prevProps.daysSelectorZoom !== this.props.daysSelectorZoom && this.state.focus) {
            this.resetFocus();
        }
    }
    selectHighlightedDates(range) {
        const { onDatesChange, selectHighlightedDates } = this.props;
        selectHighlightedDates(range);
        onDatesChange(moment(range.start, 'YYYY-MM-DD').add(1, 'day'), moment(range.end, 'YYYY-MM-DD').add(1, 'day'));
    }
    resetFocus() {
        this.setState({
            focus: false
        });
    }
    renderChart({ aggregation, isDisabled }) {
        const { conversion, standards, direction } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            className: styles.daySelector__cellChartWrapper,
            children: !isDisabled ? /*#__PURE__*/ _jsx(BloodGlucoseProfileMiniChart, {
                conversion: conversion,
                standards: standards,
                records: aggregation,
                direction: direction
            }) : /*#__PURE__*/ _jsx("div", {
                className: styles.daySelector__placeholder
            })
        });
    }
    renderButton({ isActive, isDisabled, onClick, upperLineLabel, lowerLineLabel }) {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.daySelector__cellButtonWrapper,
            children: /*#__PURE__*/ _jsxs("button", {
                className: cn('btn', 'btn--filled', styles.daySelector__cellButton, {
                    'btn--primary': isActive,
                    'btn--transparent': !isActive,
                    'btn--disabled': isDisabled,
                    [styles['daySelector__cellButton--active']]: isActive,
                    [styles['daySelector__cellButton--disabled']]: isDisabled
                }),
                onClick: onClick,
                disabled: isDisabled,
                type: "button",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        children: upperLineLabel
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        children: lowerLineLabel
                    })
                ]
            })
        });
    }
    renderDaySelector() {
        const { dailyRecordsPaginated, highlightedDates, dailyAggregations } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            className: styles.daySelector,
            children: dailyRecordsPaginated.map((dailyPreview)=>{
                const dailyAggregation = dailyAggregations.find((aggregation)=>Number(aggregation.day) === Number(dailyPreview.day) && Number(aggregation.month) === Number(dailyPreview.month) && Number(aggregation.year) === Number(dailyPreview.year));
                const isActive = highlightedDates.indexOf(dailyPreview.date) !== -1;
                // const isDisabled = !(dailyPreview.records && dailyPreview.records.length);
                const isDisabled = false;
                const isHover = this.state.focus && highlightedDates.length === 1 && (dailyPreview.date <= highlightedDates[0] && dailyPreview.date >= this.state.hover || dailyPreview.date >= highlightedDates[0] && dailyPreview.date <= this.state.hover);
                const onClick = (e)=>{
                    e.stopPropagation();
                    if (this.state.focus) {
                        if (highlightedDates.length === 1 && highlightedDates[0] === dailyPreview.date) {
                            this.setState({
                                focus: false
                            });
                            return;
                        }
                        if (highlightedDates.length === 1 && highlightedDates[0] !== dailyPreview.date) {
                            const start = highlightedDates[0];
                            const end = dailyPreview.date;
                            const range = {
                                start: start < end ? start : end,
                                end: end < start ? start : end
                            };
                            this.selectHighlightedDates(range);
                            return;
                        }
                    }
                    this.selectHighlightedDates({
                        start: dailyPreview.date,
                        end: dailyPreview.date
                    });
                    this.setState({
                        focus: true
                    });
                };
                return /*#__PURE__*/ _jsxs("div", {
                    className: cn(styles.daySelector__cell, {
                        [styles['daySelector__cell--hover']]: isHover
                    }),
                    onClick: onClick,
                    role: "presentation",
                    onMouseEnter: ()=>this.setState({
                            hover: dailyPreview.date
                        }),
                    children: [
                        this.renderButton({
                            upperLineLabel: dailyPreview.weekday,
                            lowerLineLabel: dailyPreview.date.split('-').join('/'),
                            isActive,
                            onClick
                        }),
                        this.renderChart({
                            aggregation: dailyAggregation,
                            isDisabled
                        })
                    ]
                }, dailyPreview.date);
            })
        });
    }
    renderWeekSelector() {
        const { weeklyRecordsPaginated, highlightedDates, weeklyAggregations } = this.props;
        const isSingularSelected = weeklyRecordsPaginated.map((hourlyRecords)=>hourlyRecords.dates.length && hourlyRecords.dates.map(({ date } = {})=>date).every((date)=>highlightedDates.includes(date))).filter((selected)=>selected).length === 1;
        return /*#__PURE__*/ _jsx("div", {
            className: styles.weekSelector,
            children: weeklyRecordsPaginated.map((weeklyPreview)=>{
                const weeklyAggregation = weeklyAggregations.find((aggregation)=>Number(aggregation.week + 1) === Number(weeklyPreview.weekNo) && Number(aggregation.year) === Number(weeklyPreview.year));
                const isActive = weeklyPreview.dates.length && weeklyPreview.dates.map(({ date } = {})=>date).every((date)=>highlightedDates.includes(date));
                // const isDisabled = !(weeklyPreview.records && weeklyPreview.records.length); //TODO
                const isDisabled = false;
                const firstDate = weeklyPreview.dates[0].date;
                const lastDate = weeklyPreview.dates[weeklyPreview.dates.length - 1].date;
                const isHover = this.state.focus && isSingularSelected && (firstDate <= highlightedDates[0] && lastDate >= this.state.hover || lastDate >= highlightedDates[highlightedDates.length - 1] && firstDate <= this.state.hover);
                const onClick = (e)=>{
                    e.stopPropagation();
                    if (this.state.focus) {
                        this.setState({
                            focus: false
                        });
                        if (isSingularSelected && highlightedDates[0] === firstDate && highlightedDates[highlightedDates.length - 1] === lastDate) {
                            return;
                        }
                        if (isSingularSelected && firstDate < highlightedDates[0]) {
                            const start = firstDate;
                            const end = highlightedDates[highlightedDates.length - 1];
                            this.selectHighlightedDates({
                                start,
                                end
                            });
                            return;
                        }
                        if (isSingularSelected && lastDate > highlightedDates[highlightedDates.length - 1]) {
                            const start = highlightedDates[0];
                            const end = lastDate;
                            this.selectHighlightedDates({
                                start,
                                end
                            });
                            return;
                        }
                        return;
                    }
                    this.selectHighlightedDates({
                        start: firstDate,
                        end: lastDate
                    });
                    this.setState({
                        focus: true
                    });
                };
                return /*#__PURE__*/ _jsxs("div", {
                    className: cn(styles.daySelector__cell, {
                        [styles['daySelector__cell--hover']]: isHover
                    }),
                    onClick: onClick,
                    role: "presentation",
                    onMouseEnter: ()=>this.setState({
                            hover: lastDate
                        }),
                    children: [
                        this.renderButton({
                            upperLineLabel: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.labels.week), {
                                values: {
                                    count: weeklyPreview.weekNo
                                }
                            })),
                            lowerLineLabel: `${weeklyPreview.month}/${weeklyPreview.year}`,
                            isActive,
                            onClick
                        }),
                        this.renderChart({
                            aggregation: weeklyAggregation,
                            isDisabled
                        })
                    ]
                }, weeklyPreview.weekKey);
            })
        });
    }
    renderMonthSelector() {
        const { monthlyRecordsPaginated, highlightedDates, monthlyAggregations } = this.props;
        const isSingularSelected = monthlyRecordsPaginated.map((hourlyRecords)=>hourlyRecords.dates.length && hourlyRecords.dates.map(({ date } = {})=>date).every((date)=>highlightedDates.includes(date))).filter((selected)=>selected).length === 1;
        return /*#__PURE__*/ _jsx("div", {
            className: styles.monthSelector,
            children: monthlyRecordsPaginated.map((monthlyPreview)=>{
                const monthlyAggregation = monthlyAggregations.find((aggregation)=>Number(aggregation.month) === Number(monthlyPreview.month) && Number(aggregation.year) === Number(monthlyPreview.year));
                const isActive = monthlyPreview.dates.length && monthlyPreview.dates.map(({ date } = {})=>date).every((date)=>highlightedDates.includes(date));
                // const isDisabled = !(monthlyPreview.records && monthlyPreview.records.length); // TODO
                const isDisabled = false;
                const firstDate = monthlyPreview.dates[0].date;
                const lastDate = monthlyPreview.dates[monthlyPreview.dates.length - 1].date;
                const isHover = this.state.focus && isSingularSelected && (firstDate <= highlightedDates[0] && lastDate >= this.state.hover || lastDate >= highlightedDates[highlightedDates.length - 1] && firstDate <= this.state.hover);
                const onClick = (e)=>{
                    e.stopPropagation();
                    if (this.state.focus) {
                        this.setState({
                            focus: false
                        });
                        if (isSingularSelected && highlightedDates[0] === firstDate && highlightedDates[highlightedDates.length - 1] === lastDate) {
                            return;
                        }
                        if (isSingularSelected && firstDate < highlightedDates[0]) {
                            const start = firstDate;
                            const end = highlightedDates[highlightedDates.length - 1];
                            this.selectHighlightedDates({
                                start,
                                end
                            });
                            return;
                        }
                        if (isSingularSelected && lastDate > highlightedDates[highlightedDates.length - 1]) {
                            const start = highlightedDates[0];
                            const end = lastDate;
                            this.selectHighlightedDates({
                                start,
                                end
                            });
                            return;
                        }
                        return;
                    }
                    this.selectHighlightedDates({
                        start: firstDate,
                        end: lastDate
                    });
                    this.setState({
                        focus: true
                    });
                };
                return /*#__PURE__*/ _jsxs("div", {
                    className: cn(styles.daySelector__cell, {
                        [styles['daySelector__cell--hover']]: isHover
                    }),
                    onClick: onClick,
                    role: "presentation",
                    onMouseEnter: ()=>this.setState({
                            hover: lastDate
                        }),
                    children: [
                        this.renderButton({
                            upperLineLabel: monthlyPreview.monthName,
                            lowerLineLabel: `${monthlyPreview.month}/${monthlyPreview.year}`,
                            onClick,
                            isActive
                        }),
                        this.renderChart({
                            aggregation: monthlyAggregation,
                            isDisabled
                        })
                    ]
                }, monthlyPreview.monthKey);
            })
        });
    }
    renderSelector() {
        const { daysSelectorZoom } = this.props;
        switch(daysSelectorZoom){
            case DAYS_SELECTOR_ZOOM.day:
                {
                    return this.renderDaySelector();
                }
            case DAYS_SELECTOR_ZOOM.week:
                {
                    return this.renderWeekSelector();
                }
            case DAYS_SELECTOR_ZOOM.month:
                {
                    return this.renderMonthSelector();
                }
            default:
                return null;
        }
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.root,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.header,
                    children: /*#__PURE__*/ _jsx(DaysSelectorControlBtn, {})
                }),
                this.renderSelector()
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            hover: null,
            focus: false
        };
    }
}
_define_property(DaysSelector, "propTypes", {
    // Implicit props
    daysSelectorZoom: PropTypes.string,
    dailyRecords: dailyRecordsShape,
    dailyRecordsPaginated: dailyRecordsShape,
    weeklyRecordsPaginated: weeklyRecordsShape,
    monthlyRecordsPaginated: monthlyRecordsShape,
    highlightedDates: PropTypes.arrayOf(PropTypes.string),
    preview: previewShape,
    monthlyAggregations: PropTypes.arrayOf(PropTypes.shape({
        hourlyBins: PropTypes.arrayOf(PropTypes.object),
        month: PropTypes.number,
        year: PropTypes.number
    })),
    weeklyAggregations: PropTypes.arrayOf(PropTypes.shape({
        hourlyBins: PropTypes.arrayOf(PropTypes.object),
        month: PropTypes.number,
        year: PropTypes.number,
        week: PropTypes.number
    })),
    dailyAggregations: PropTypes.arrayOf(PropTypes.shape({
        hourlyBins: PropTypes.arrayOf(PropTypes.object),
        month: PropTypes.number,
        year: PropTypes.number,
        week: PropTypes.number,
        day: PropTypes.number
    })),
    // Implicit actions
    selectHighlightedDates: PropTypes.func,
    onDatesChange: PropTypes.func,
    // Explicit props
    conversion: PropTypes.object.isRequired,
    standards: PropTypes.shape({
        maxValue: PropTypes.number.isRequired,
        preMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        }),
        postMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        })
    }),
    direction: PropTypes.string
});
const mapStateToProps = (state)=>({
        daysSelectorZoom: selectors.daysSelectorZoom(state),
        preview: selectors.preview(state),
        dailyRecords: selectors.dailyRecords(state),
        dailyRecordsPaginated: selectors.dailyRecordsPaginated(state),
        weeklyRecordsPaginated: selectors.weeklyRecordsPaginated(state),
        monthlyRecordsPaginated: selectors.monthlyRecordsPaginated(state),
        highlightedDates: selectors.highlightedDates(state),
        highlightedHourlyRecords: selectors.highlightedHourlyRecords(state),
        direction: App.selectors.direction(state),
        monthlyAggregations: selectors.monthlyAggregations(state),
        weeklyAggregations: selectors.weeklyAggregations(state),
        dailyAggregations: selectors.dailyAggregations(state)
    });
const mapDispatchToProps = (dispatch)=>({
        selectHighlightedDates: (range)=>dispatch(actions.selectHighlightedDates(range))
    });
const ConnectedDaysSelector = connect(mapStateToProps, mapDispatchToProps)(DaysSelector);
export default withStyles(styles)(ConnectedDaysSelector);
